module.exports = __webpack_public_path__ + "img/product-img.8600b2da.png";